<template>    
    <div class="py-4 container-fluid">
        <div class="card mb-5" ref="pdfContent">
            <div class="row mb-5 pdf-logo-section">
                <div class="col-lg-12">
                    <div class="card-header p-3 pt-2">
                        <img
                            :src="isLoading ? loadingImageUrl : associationLogoImageSrc"
                            :alt="$t('association.Logo_image')"
                            style="width: 200px;"
                            />  
                        <h6 class="mb-2">{{ animal.associationName }}</h6>
                    </div>
                </div>
                <!-- LEFT: animal overview -->
                <div class="col-lg-4 pdf-animal-details">
                    <div class="card-header p-3 pt-2">
                        <h4>Overzicht afstamming van</h4>
                        <div>
                            <dl class="row mb-0 small">
                                <dt class="col-6 text-muted">Stamboeknummer: </dt><dd class="col-6 line-height-20">{{ animal.studbookNumber }}&nbsp;</dd> 
                                <dt class="col-6 text-muted">Levensnummer: </dt><dd class="col-6 line-height-20">{{ animal.tagNumber }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Landcode: </dt><dd class="col-6 line-height-20">{{ animal.countryCode }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Ras:  </dt><dd class="col-6 line-height-20">{{ animal.breedName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Kleur: </dt><dd class="col-6 line-height-20">{{ animal.colorName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Naam: </dt><dd class="col-6 line-height-20">{{ animal.animalName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Geslacht: </dt><dd class="col-6 line-height-20">{{ animal.gender }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Geboortedatum: </dt><dd class="col-6 line-height-20">{{ animal.birthDate }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Worpgrootte: </dt><dd class="col-6 line-height-20">{{ animal.litterSize }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Aantal worpen: </dt><dd class="col-6 line-height-20">{{ animal.noParities }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Aantal lammeren: </dt><dd class="col-6 line-height-20">{{ animal.noLambs }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Genotype Scrapie: </dt><dd class="col-6 line-height-20">{{ animal.genoTypeName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Genotype Zwoeger: </dt><dd class="col-6 line-height-20">{{ animal.genoTypeName2 }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Stamboeksectie: </dt><dd class="col-6 line-height-20">{{ animal.studebookSectionDescription }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Status: </dt><dd class="col-6 line-height-20">{{ animal.studebookStatus }}&nbsp;</dd>
                                                                
                                <!-- KEURSTW -->
                                <template v-for="attr in keurstwItems" :key="attr.code">
                                    <dt class="col-6 text-muted">{{ attr.name }}:</dt>
                                    <dd class="col-6 line-height-20">{{ attr.value }}&nbsp;</dd>
                                </template>

                                <!-- KEURPNT -->
                                <template v-for="attr in keurpntItems" :key="attr.code">
                                    <dt class="col-6 text-muted">{{ attr.name }}:</dt>
                                    <dd class="col-6 line-height-20">{{ attr.value }}&nbsp;</dd>
                                </template>

                                <dt class="col-6 text-muted">Fokker: </dt><dd class="col-6 line-height-20">{{ animal.breederName }}&nbsp;</dd>
                                <dt class="col-6 text-muted">Houder: </dt><dd class="col-6 line-height-20">{{ animal.keeperName }}&nbsp;</dd>
                            </dl>
                        </div>
                        <!-- Add Offspring table here-->
                         <div class="offspring-section mt-4" data-hide-pdf>
                            <div class="offspring-title">
                                Nakomelingen:                            
                            </div>
                            <div class="table-responsive">
                                <table class="table table-sm table-bordered offspring-table mb-0">
                                    <thead>
                                        <tr>
                                            <th>Stamboeknummer</th>
                                            <th>Levensnummer</th>
                                            <th>Gesl</th>
                                            <th>Worpgrootte</th>
                                            <th>Worpen</th>
                                            <th>Lammeren</th>
                                            <th>Ras</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="offspring in animal.offspring" :key="offspring.animalId">
                                            <td>
                                                <a
                                                    v-if="offspring.animalId"
                                                    :href="`/animal/pedigree/${offspring.animalId}`"
                                                    class="offspring-studbook-link"                                                    
                                                >
                                                    {{ offspring.studbookNumber || '' }}
                                                </a>

                                                <span v-else>
                                                    {{ offspring.studbookNumber || '' }}
                                                </span>
                                            </td>
                                            <td>{{ offspring.tagNumber || '' }}</td>
                                            <td>{{ offspring.gender || '' }}</td>
                                            <td>{{ offspring.litterSize ?? '' }}</td>
                                            <td>{{ offspring.noParities ?? '' }}</td>
                                            <td>{{ offspring.noLambs ?? '' }}</td>
                                            <td>{{ offspring.breed || '' }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- RIGHT: pedigree L→R rows with brackets -->
                <div class="col-lg-8 ped-row-right">

                    <!-- ROW 1: FATHER SIDE -->
                    <div class="ped-row mb-5">
                        <!-- LEFT: father card -->
                        <div class="ped-left">
                            <PedigreeCard
                                v-if="pedigree1?.selectedanimal?.father"
                                :node="pedigree1?.selectedanimal.father"
                                label="Vader"
                                :id="pedigree1?.selectedanimal.father.id"
                            />
                        </div>
                        <!-- RIGHT: father's parents + grandparents -->
                        <div class="ped-right">
                            <!-- FATHER'S FATHER -->
                            <div v-if="pedigree1?.selectedanimal.father?.father" class="branch">
                                <!-- Generation 2 -->
                                <div class="parent">
                                    <PedigreeCard
                                        :node="pedigree1?.selectedanimal.father.father"
                                        label="Vader"
                                        :id="pedigree1?.selectedanimal.father.father.id"
                                    />
                                </div>
                                <!-- Generation 3 -->
                                <div class="children">
                                    <!-- Grandfather's father -->
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1?.selectedanimal.father?.father?.father"
                                            :node="pedigree1?.selectedanimal.father.father.father"
                                            label="Vader"
                                            :id="pedigree1?.selectedanimal.father.father.father.id"
                                            :wide="true"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData label="Vader" />
                                        </div>
                                    </div>
                                    <!-- Grandfather's mother -->
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1?.selectedanimal.father?.father?.mother"
                                            :node="pedigree1?.selectedanimal.father.father.mother"
                                            label="Moeder"
                                            :id="pedigree1?.selectedanimal.father.father.mother.id"
                                            :wide="true"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData label="Moeder" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- FATHER'S MOTHER -->
                            <div v-if="pedigree1?.selectedanimal.father?.mother" class="branch mt-4">
                                <!-- Generation 2 -->
                                <div class="parent">
                                    <PedigreeCard
                                        :node="pedigree1?.selectedanimal.father.mother"
                                        label="Moeder"
                                        :id="pedigree1?.selectedanimal.father.mother.id"
                                    />
                                </div>
                                <!-- Generation 3 -->
                                <div class="children">
                                    <!-- Grandmother's father -->
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1?.selectedanimal.father?.mother?.father"
                                            :node="pedigree1?.selectedanimal.father.mother.father"
                                            label="Vader"
                                            :id="pedigree1?.selectedanimal.father.mother.father.id"
                                            :wide="true"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData label="Vader" />
                                        </div>
                                    </div>
                                    <!-- Grandmother's mother -->
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1?.selectedanimal.father?.mother?.mother"
                                            :node="pedigree1?.selectedanimal.father.mother.mother"
                                            label="Moeder"
                                            :id="pedigree1?.selectedanimal.father.mother.mother.id"
                                            :wide="true"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData label="Moeder" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- ROW 2: MOTHER SIDE -->
                    <div class="ped-row">
                        <!-- LEFT: mother card -->
                        <div class="ped-left">
                            <PedigreeCard
                                v-if="pedigree1?.selectedanimal?.mother"
                                :node="pedigree1?.selectedanimal.mother"
                                label="Moeder"
                                :id="pedigree1?.selectedanimal.mother.id"
                            />
                        </div>
                        <!-- RIGHT: mother's parents + grandparents -->
                        <div class="ped-right">
                            <!-- MOTHER'S FATHER -->
                            <div v-if="pedigree1?.selectedanimal.mother?.father" class="branch">
                                <!-- Generation 2 -->
                                <div class="parent">
                                    <PedigreeCard
                                        :node="pedigree1?.selectedanimal.mother.father"
                                        label="Vader"
                                        :id="pedigree1?.selectedanimal.mother.father.id"
                                    />
                                </div>
                                <!-- Generation 3 -->
                                <div class="children">
                                    <!-- Grandfather's father -->
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1?.selectedanimal.mother?.father?.father"
                                            :node="pedigree1?.selectedanimal.mother.father.father"
                                            label="Vader"
                                            :id="pedigree1?.selectedanimal.mother.father.father.id"
                                            :wide="true"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData label="Vader" />
                                        </div>
                                    </div>
                                    <!-- Grandfather's mother -->
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1?.selectedanimal.mother?.father?.mother"
                                            :node="pedigree1?.selectedanimal.mother.father.mother"
                                            label="Moeder"
                                            :id="pedigree1?.selectedanimal.mother.father.mother.id"
                                            :wide="true"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData label="Moeder" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- MOTHER'S MOTHER -->
                            <div v-if="pedigree1?.selectedanimal.mother?.mother" class="branch mt-4">
                                <!-- Generation 2 -->
                                <div class="parent">
                                    <PedigreeCard
                                        :node="pedigree1?.selectedanimal.mother.mother"
                                        label="Moeder"
                                        :id="pedigree1?.selectedanimal.mother.mother.id"
                                    />
                                </div>
                                <!-- Generation 3 -->
                                <div class="children">
                                    <!-- Grandmother's father -->
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1?.selectedanimal.mother?.mother?.father"
                                            :node="pedigree1?.selectedanimal.mother.mother.father"
                                            label="Vader"
                                            :id="pedigree1?.selectedanimal.mother.mother.father.id"
                                            :wide="true"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData label="Vader" />
                                        </div>
                                    </div>
                                    <!-- Grandmother's mother -->
                                    <div class="child">
                                        <PedigreeCard
                                            v-if="pedigree1?.selectedanimal.mother?.mother?.mother"
                                            :node="pedigree1?.selectedanimal.mother.mother.mother"
                                            label="Moeder"
                                            :id="pedigree1?.selectedanimal.mother.mother.mother.id"
                                            :wide="true"
                                        />
                                        <div v-else>
                                            <PedigreeCardNoData label="Moeder" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>        
        <div class="row">
            <div class="col-12 col-sm-12 mt-2">
                <router-link v-if="!isEmbedded" to="/animal" class="btn btn-sm bg-gradient-danger float-start  ms-2">{{ $t('common.Cancel') }}</router-link>
                <button v-on:click="downloadPdf" class="btn btn-sm bg-gradient-success mr-2 me-2 float-end">{{ $t('common.Download_PDF') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import jsPDF from 'jspdf';
import { defineComponent, h } from 'vue';
import loadingImageUrl from '@/assets/img/LoadingImage.gif';
import noImageUrl from '@/assets/no-image.png';
import html2canvas from 'html2canvas';
import { useRouter } from 'vue-router';


/* ============================================================
   PEDIGREE CARD
   ============================================================ */

const PedigreeCard = defineComponent({
    name: 'PedigreeCard',

    props: {
        node: {
            type: Object,
            required: true
        },

        label: {
            type: String,
            default: ''
        },

        level: {
            type: Number,
            default: 0
        },

        id: {
            type: [String, Number],
            default: ''
        },

        /*
         * false = 5 + 5 keurpunten
         * true  = all 10 keurpunten in one row
         */
        wide: {
            type: Boolean,
            default: false
        }
    },

    setup(props) {

        const router = useRouter();

        /* OPEN PREVIEW */
        const goToPreview = () => {

            if (!props.id) {
                return;
            }

            router.push({
                name: 'Preview Animal',

                params: {
                    id: props.id
                },

                query: {
                    call: 'pedigree'
                }
            });
        };

        const getGenderLabel = () => {

            if (props.label) {
                return props.label;
            }

            return props.node?.gender === 'M'
                ? 'Vader'
                : 'Moeder';
        };


        const getIsMale = () => {

            return (
                props.label === 'Vader' ||
                props.node?.gender === 'M'
            );
        };

        const getValue = (value) => {

            return (
                value !== null &&
                value !== undefined &&
                value !== ''
            )
                ? value
                : '—';
        };

        /* KEURPUNTEN */
        const createWideHeader = () => {

            return h(
                'tr',
                {},
                [
                    h('th', { class: 'bg-light text-dark' }, 'HF'),
                    h('th', { class: 'bg-light text-dark' }, 'HO'),
                    h('th', { class: 'bg-light text-dark' }, 'NE'),
                    h('th', { class: 'bg-light text-dark' }, 'VH'),
                    h('th', { class: 'bg-light text-dark' }, 'MH'),
                    h('th', { class: 'bg-light text-dark' }, 'AH'),
                    h('th', { class: 'bg-light text-dark' }, 'BW'),
                    h('th', { class: 'bg-light text-dark' }, 'ST'),
                    h('th', { class: 'bg-light text-dark' }, 'HV'),
                    h('th', { class: 'bg-light text-dark' }, 'AV')
                ]
            );
        };

        const createWideValues = () => {

            return h(
                'tr',
                {},
                [
                    h('td', {}, getValue(props.node?.keurPunten?.HF)),
                    h('td', {}, getValue(props.node?.keurPunten?.HO)),
                    h('td', {}, getValue(props.node?.keurPunten?.NE)),
                    h('td', {}, getValue(props.node?.keurPunten?.VH)),
                    h('td', {}, getValue(props.node?.keurPunten?.MH)),
                    h('td', {}, getValue(props.node?.keurPunten?.AH)),
                    h('td', {}, getValue(props.node?.keurPunten?.BW)),
                    h('td', {}, getValue(props.node?.keurPunten?.ST)),
                    h('td', {}, getValue(props.node?.keurPunten?.HV)),
                    h('td', {}, getValue(props.node?.keurPunten?.AV))
                ]
            );
        };

        const createNormalHeader1 = () => {

            return h(
                'tr',
                {},
                [
                    h('th', { class: 'bg-light text-dark' }, 'HF'),
                    h('th', { class: 'bg-light text-dark' }, 'HO'),
                    h('th', { class: 'bg-light text-dark' }, 'NE'),
                    h('th', { class: 'bg-light text-dark' }, 'VH'),
                    h('th', { class: 'bg-light text-dark' }, 'MH')
                ]
            );
        };

        const createNormalValues1 = () => {

            return h(
                'tr',
                {},
                [
                    h('td', {}, getValue(props.node?.keurPunten?.HF)),
                    h('td', {}, getValue(props.node?.keurPunten?.HO)),
                    h('td', {}, getValue(props.node?.keurPunten?.NE)),
                    h('td', {}, getValue(props.node?.keurPunten?.VH)),
                    h('td', {}, getValue(props.node?.keurPunten?.MH))
                ]
            );
        };

        const createNormalHeader2 = () => {

            return h(
                'tr',
                {},
                [
                    h('th', { class: 'bg-light text-dark' }, 'AH'),
                    h('th', { class: 'bg-light text-dark' }, 'BW'),
                    h('th', { class: 'bg-light text-dark' }, 'ST'),
                    h('th', { class: 'bg-light text-dark' }, 'HV'),
                    h('th', { class: 'bg-light text-dark' }, 'AV')
                ]
            );
        };

        const createNormalValues2 = () => {

            return h(
                'tr',
                {},
                [
                    h('td', {}, getValue(props.node?.keurPunten?.AH)),
                    h('td', {}, getValue(props.node?.keurPunten?.BW)),
                    h('td', {}, getValue(props.node?.keurPunten?.ST)),
                    h('td', {}, getValue(props.node?.keurPunten?.HV)),
                    h('td', {}, getValue(props.node?.keurPunten?.AV))
                ]
            );
        };

        /* RENDER */
        return () => {

            const genderLabel = getGenderLabel();
            const isMale = getIsMale();

            const studbookNumber = getValue(props.node?.studbooknumber);
            const tagNumber = getValue(props.node?.tagnumber);
            const countryCode = getValue(props.node?.countrycode);
            const name = getValue(props.node?.name);
            const birthDate = getValue(props.node?.birthdate);
            const genotype = getValue(props.node?.genotype);
            const litterSize = getValue(props.node?.siblings);
            const parities = getValue(props.node?.nobirths);
            const lambs = getValue(props.node?.nolambs);

            /* SIDE LABEL */
            const sideLabel = h(
                'div',
                {
                    class: ['pedigree-side-label', isMale ? 'bg-male' : 'bg-female' ]
                },
                [
                    h('span', {class: 'pedigree-side-label-text'}, genderLabel)
                ]
            );

            /* STUD BOOK / TAG / COUNTRY */
            const studbookContent = props.node?.id
                ? h('a', {href: `/animal/pedigree/${props.node.id}`, class: 'pedigree-studbook-link'}, studbookNumber) : studbookNumber;


            const identification = h(
                'div',
                {
                    class: 'pedigree-identification-row'
                },
                [
                    h('div', {class: 'pedigree-identification-text'}, [studbookContent, ' | ', tagNumber, ' | ', countryCode]),
                    h('a',{class: 'pedigree-preview-icon', 'data-hide-pdf': 'true', title: 'Voorbeeld', onClick: goToPreview},
                        [h('i', {class: 'material-symbols-rounded', 'aria-hidden': 'true'}, 'table_eye')]
                    )
                ]
            );

            /* NAME */
            const nameElement = h(
                'div', {class: 'fw-semibold mb-1'},[h('span', {class: 'fw-bold'}, 'Naam: '), name]
            );

            /* DETAILS */
            const detailsElement = props.wide

                ? h(
                    'div',
                    {
                        class: 'fw-semibold mb-1 wide-details'
                    },
                    [
                        h(
                            'span',
                            {
                                class: 'fw-bold'
                            },
                            'Geb: '
                        ),

                        birthDate,

                        ' | ',

                        genotype,

                        ' | ',

                        h(
                            'span',
                            {
                                class: 'fw-bold'
                            },
                            'Worpgrootte: '
                        ),

                        litterSize,

                        ' | ',

                        h(
                            'span',
                            {
                                class: 'fw-bold'
                            },
                            'Worpen: '
                        ),

                        parities,

                        ' | ',

                        h(
                            'span',
                            {
                                class: 'fw-bold'
                            },
                            'Lammeren: '
                        ),

                        lambs
                    ]
                )

                : h(
                    'div',
                    {},
                    [
                        h(
                            'div',
                            {
                                class: 'fw-semibold mb-1'
                            },
                            [
                                h(
                                    'span',
                                    {
                                        class: 'fw-bold'
                                    },
                                    'Geb: '
                                ),

                                birthDate,

                                ' | ',

                                genotype
                            ]
                        ),

                        h(
                            'div',
                            {
                                class: 'fw-semibold mb-1'
                            },
                            [
                                h(
                                    'span',
                                    {
                                        class: 'fw-bold'
                                    },
                                    'Worpgrootte: '
                                ),

                                litterSize,

                                ' | ',

                                h(
                                    'span',
                                    {
                                        class: 'fw-bold'
                                    },
                                    'Worpen: '
                                ),

                                parities,

                                ' | ',

                                h(
                                    'span',
                                    {
                                        class: 'fw-bold'
                                    },
                                    'Lammeren: '
                                ),

                                lambs
                            ]
                        )
                    ]
                );


            /* KEURPUNTEN TABLE */
            const tableRows = props.wide
                ? [createWideHeader(), createWideValues()]
                : [createNormalHeader1(), createNormalValues1(), createNormalHeader2(), createNormalValues2()];

            const keurpuntenTable = h(
                'table',
                {
                    class: [
                        'table',
                        'table-sm',
                        'table-bordered',
                        'text-center',
                        'mt-2',
                        'keurpunten-table',
                        props.wide
                            ? 'keurpunten-wide'
                            : 'keurpunten-normal'
                    ]
                },
                [h('tbody', {}, tableRows)]
            );

            /* CARD BODY */
            const cardBody = h('div', {class: 'card-body p-2 small'},[identification, nameElement, detailsElement, keurpuntenTable]);

            /* MAIN CARD */
            const card = h(
                'div', {class: ['card', 'card-node', 'border-0',  'shadow-sm', 'text-nowrap']}, [cardBody]
            );

            /* FINAL WRAPPER */
            return h('div', {class: 'pedigree-card-wrapper'}, [sideLabel, card]);
        };
    }
});

/* PEDIGREE CARD - NO DATA */
const PedigreeCardNoData = defineComponent({
    name: 'PedigreeCardNoData',

    props: {
        node: {
            type: Object,
            default: null
        },

        label: {
            type: String,
            default: ''
        },

        level: {
            type: Number,
            default: 0
        }
    },

    setup(props) {

        return () => {
            const genderLabel = props.label || (props.node?.gender === 'M' ? 'Vader' : 'Moeder');
            const isMale = genderLabel === 'Vader';

            /* SIDE LABEL */
            const sideLabel = h(
                'div', {class: ['pedigree-side-label', isMale ? 'bg-male' : 'bg-female']},
                [h('span', {class: 'pedigree-side-label-text'}, genderLabel)]
            );

            /* EMPTY CARD */
            const card = h(
                'div',
                {
                    class: [
                        'card',
                        'card-node',
                        'border-0',
                        'shadow-sm',
                        'text-nowrap'
                    ]
                },
                [
                    h(
                        'div',
                        {
                            class: [
                                'card-header',
                                'card-header-custom',
                                'py-1',
                                'px-2',
                                isMale
                                    ? 'bg-male'
                                    : 'bg-female'
                            ],

                            style: {
                                minHeight: '38px',
                                padding: '8px 10px'
                            }
                        }
                    ),

                    h(
                        'div',
                        {
                            class: 'card-body p-2 small'
                        },
                        [
                            h(
                                'div',
                                {
                                    class: 'fw-semibold mb-1'
                                },
                                'Geen gegevens gevonden'
                            )
                        ]
                    )
                ]
            );


            return h(
                'div',
                {
                    class: 'pedigree-card-wrapper'
                },
                [
                    sideLabel,
                    card
                ]
            );
        };
    }
});


/* MAIN COMPONENT */
export default {

    name: 'Pedigree_page',

    components: {
        PedigreeCard,
        PedigreeCardNoData
    },
    data() {

        return {
            animalId: '',
            associationLogoImageSrc: noImageUrl,
            isLoading: false,
            loadingImageUrl,
            animal: {
                keurstw: {
                    items: []
                },
                keurpnt: {
                    items: []
                }
            },
            gets: [],

            pedigree1: {
                selectedanimal: {}
            }
        };
    },
    computed: {
        isEmbedded() {
            return this.$route.query.embed === 'true';
        },
        keurstwItems() {
            if (
                this.animal &&
                this.animal.keurstw &&
                Array.isArray(this.animal.keurstw.items)
            ) {
                return this.animal.keurstw.items;
            }

            return [];
        },
        keurpntItems() {
            if (
                this.animal &&
                this.animal.keurpnt &&
                Array.isArray(this.animal.keurpnt.items)
            ) {
                return this.animal.keurpnt.items;
            }

            return [];
        }
    },
    async mounted() {
        try {

            this.animalId = this.$route.params.id;

            console.log('Pedigree animal ID:', this.animalId);

            await this.fetchAnimalPedigree(this.animalId);
        } catch (e) {

            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);

        } finally {
            this.$store.commit('setShowLoading', false);
        }
    },
    methods: {
        coercePedigree(input) {
            const emptyPedigree = {
                selectedanimal: {}
            };

            if (!input) {
                return emptyPedigree;
            }

            if (typeof input === 'object') {

                if (!input.selectedanimal) {
                    return {
                        ...input,
                        selectedanimal: {}
                    };
                }
                return input;
            }

            if (typeof input === 'string') {

                try {
                    const parsed = JSON.parse(input);
                    const pedigree = parsed?.pedigree ?? parsed;

                    if (pedigree && typeof pedigree === 'object') {
                        return {
                            ...pedigree,
                            selectedanimal: pedigree.selectedanimal || {}
                        };
                    }
                } catch (err) {
                    console.error('Invalid pedigree JSON:', err);
                }
            }
            return emptyPedigree;
        },
        formatDate(dateStr) {

            if (!dateStr) {
                return '';
            }

            const d = new Date(dateStr);

            if (Number.isNaN(d.getTime())) {
                return '';
            }

            const day = String(d.getDate()).padStart(2, '0');
            const month =String(d.getMonth() + 1).padStart(2, '0');
            const year =d.getFullYear();
            return `${day}-${month}-${year}`;
        },
        normalizeAnimalData(raw) {

            const a = raw || {};
            const safeItems =
                (group) => {
                    if (group && Array.isArray(group.items)) {
                        return group.items;
                    }
                    return [];
                };

            return {
                ...a,
                keurstw: {
                    items: safeItems(a.keurstw)
                },
                keurpnt: {
                    items: safeItems(a.keurpnt)
                }
            };
        },
        async fetchAnimalPedigree(animalId) {
            try {

                this.isLoading = true;
                this.$store.commit('setShowLoading', true);

                const response = await axios.get('Animal/getpedigree', {params: {animalId}});
                this.gets = response.data;

                if (this.gets.success) {

                    this.animal =this.normalizeAnimalData(this.gets.data);

                    let logoSrc = this.animal?.logoDataUrl || '';
                    if (!logoSrc && this.animal?.logoBase64 && this.animal?.contentType?.startsWith('image/')) {
                        logoSrc = `data:${this.animal.contentType};base64,${this.animal.logoBase64}`;
                    }

                    this.associationLogoImageSrc = logoSrc || noImageUrl;

                    this.pedigree1 = this.coercePedigree(this.animal?.pedigree);

                    console.log('Pedigree:', this.pedigree1);
                } else {
                    this.$showError(this.$t('errors.Contact_system_admin'));
                }
            } catch (e) {

                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);

            } finally {

                this.isLoading = false;
                this.$store.commit('setShowLoading', false);
            }
        },
        async downloadPdf() {

            const root = this.$refs.pdfContent;

            if (!root) {
                return;
            }

            await this.$nextTick();

            root.classList.add('pdf-lower-selected-animal');
            const hidden = [];

            root
                .querySelectorAll('[data-hide-pdf]')
                .forEach(el => {
                    hidden.push({el, display: el.style.display});
                    el.style.display = 'none';
                });

            const oldOverflow = root.style.overflow;
            try {
                root.style.overflow = 'visible';
                await this.$nextTick();

                await new Promise(resolve =>
                    requestAnimationFrame(resolve)
                );

                const fullWidth = root.scrollWidth;
                const fullHeight = root.scrollHeight;

                const canvas =
                    await html2canvas(
                        root,
                        {
                            backgroundColor: '#ffffff',
                            useCORS: true,
                            scale: 2,
                            width: fullWidth,
                            height: fullHeight,
                            windowWidth: fullWidth,
                            windowHeight: fullHeight
                        }
                    );

                const ctx = canvas.getContext('2d', {willReadFrequently: true});
                const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                const pixels = imageData.data;

                let minX = canvas.width;
                let minY = canvas.height;
                let maxX = 0;
                let maxY = 0;

                const threshold = 250;

                for (let y = 0; y < canvas.height; y++) {
                    for (let x = 0; x < canvas.width; x++) {

                        const index = (y * canvas.width + x) * 4;
                        const r = pixels[index];
                        const g = pixels[index + 1];
                        const b = pixels[index + 2];
                        const a = pixels[index + 3];

                        if (a > 0 && (r < threshold || g < threshold || b < threshold)) {
                            if (x < minX) {
                                minX = x;
                            }

                            if (y < minY) {
                                minY = y;
                            }

                            if (x > maxX) {
                                maxX = x;
                            }

                            if (y > maxY) {
                                maxY = y;
                            }
                        }
                    }
                }

                if (minX >= canvas.width || minY >= canvas.height) {
                    minX = 0;
                    minY = 0;

                    maxX = canvas.width - 1;
                    maxY = canvas.height - 1;
                }

                const padding = 12;
                minX = Math.max(0, minX - padding);
                minY = Math.max(0, minY - padding);
                maxX = Math.min(canvas.width - 1, maxX + padding);
                maxY = Math.min(canvas.height - 1, maxY + padding);

                const cropWidth = maxX - minX + 1;
                const cropHeight = maxY - minY + 1;
                const croppedCanvas = document.createElement('canvas');
                croppedCanvas.width = cropWidth;
                croppedCanvas.height = cropHeight;
                const croppedCtx = croppedCanvas.getContext('2d');

                croppedCtx.fillStyle = '#ffffff';
                croppedCtx.fillRect(0, 0, cropWidth, cropHeight);
                croppedCtx.drawImage(canvas, minX, minY, cropWidth, cropHeight, 0, 0, cropWidth, cropHeight);

                const imgData = croppedCanvas.toDataURL('image/png');

                const pdf = new jsPDF({orientation: 'landscape', unit: 'mm', format: 'a4'});

                const pageW = pdf.internal.pageSize.getWidth();
                const pageH = pdf.internal.pageSize.getHeight();

                const margin = 5;
                const availableW = pageW - (margin * 2);
                const availableH = pageH - (margin * 2);

                const imageRatio = cropWidth / cropHeight;
                const pageRatio = availableW / availableH;

                let renderW;
                let renderH;

                if (imageRatio > pageRatio) {
                    /* Content is wider */
                    renderW = availableW;
                    renderH = renderW / imageRatio;
                } else {
                    /* Content is taller */
                    renderH = availableH;
                    renderW = renderH * imageRatio;
                }

                const x = (pageW - renderW) / 2;
                const y = (pageH - renderH) / 2;

                pdf.addImage(imgData, 'PNG', x, y, renderW, renderH);

                pdf.save('Pedigree.pdf');
            } catch (error) {
                console.error('PDF generation error:', error);

            } finally {
                root.style.overflow = oldOverflow;
                hidden.forEach(
                    ({ el, display }) => {
                        el.style.display = display;
                    }
                );

                root.classList.remove('pdf-lower-selected-animal');
            }
        },        
    }
};
</script>

<style scoped>
    .line-height-20 {
        line-height: 20px;
    }

    .pdf-page.a4-landscape {
        width: 1122px;
        min-height: 793px;
        padding: 20px;
        box-sizing: border-box;
        background: #ffffff;
    }

    .no-data-box {
        border: 2px solid red;
        padding: 1rem;
        border-radius: 6px;
        color: red;
        text-align: center;
        font-weight: 500;
    }


    :deep(.bg-male) {
        background: #4e61d3 !important;
    }

    :deep(.bg-female) {
        background: #d63384 !important;
    }

    :deep(.pedigree-card-wrapper) {
        display: flex;
        align-items: stretch;
        position: relative;

        width: max-content;

        box-sizing: border-box;
    }

    :deep(.pedigree-side-label) {
        position: relative;

        width: 28px;
        min-width: 28px;

        align-self: stretch;

        display: block;

        color: #ffffff;

        font-size: 11px;
        font-weight: 600;

        border-radius: 5px 0 0 5px;

        box-sizing: border-box;

        overflow: hidden;

        z-index: 3;
    }

    :deep(.pedigree-side-label-text) {
        position: absolute;

        left: 50%;
        top: 50%;

        display: block;

        white-space: nowrap;

        color: #ffffff;

        font-size: 20px;
        font-weight: 600;

        line-height: 1;

        transform: translate(-50%, -50%) rotate(-90deg);

        transform-origin: center center;

        margin: 0;
        padding: 0;
    }

    :deep(.pedigree-side-label.bg-male) {
        background: #4e61d3 !important;
    }

    :deep(.pedigree-side-label.bg-female) {
        background: #d63384 !important;
    }

    :deep(.pedigree-card-wrapper > .card-node) {
        width: 320px;
        min-width: 320px;
        max-width: 320px;

        box-sizing: border-box;

        margin: 0;

        border-radius: 0 6px 6px 0 !important;

        position: relative;

        z-index: 2;
    }

    :deep(.pedigree-card-wrapper .card-header) {
        border-radius: 0 6px 0 0 !important;

        color: #ffffff !important;

        display: flex;
        align-items: center;

        min-height: 38px;

        box-sizing: border-box;
    }

    :deep(.pedigree-preview-icon) {
        margin-left: auto;

        display: inline-flex;

        align-items: center;
        justify-content: center;

        color: #ffffff;

        text-decoration: none;

        cursor: pointer;

        line-height: 1;
    }


    :deep(.pedigree-preview-icon i) {
        font-size: 1.2rem;
    }

    :deep(.pedigree-studbook-link) {
        color: #0f8d09;

        text-decoration: none;

        cursor: pointer;
    }


    :deep(.pedigree-studbook-link:hover) {
        text-decoration: underline;
    }

    :deep(.keurpunten-table) {
        width: 100%;

        table-layout: fixed;

        border-collapse: collapse;

        margin-bottom: 0;
    }


    :deep(.keurpunten-table th),
    :deep(.keurpunten-table td) {

        padding: 3px 4px !important;

        font-size: 12px !important;

        text-align: center;

        white-space: nowrap;

        vertical-align: middle;
    }


    :deep(.keurpunten-normal th),
    :deep(.keurpunten-normal td) {
        width: 20%;
    }

    :deep(.keurpunten-wide th),
    :deep(.keurpunten-wide td) {
        width: 10%;
    }

    .ped-row {
        display: flex;

        align-items: center;

        gap: 80px;

        margin-bottom: 50px;
    }

    .ped-left {
        position: relative;

        display: flex;

        align-items: center;

        justify-content: center;
    }

    .ped-left::after {
        content: "";

        position: absolute;

        right: -43px;

        top: 50%;

        width: 40px;

        height: 2px;

        background: #d9dee3;

        transform: translateY(-50%);
    }

    .ped-right {
        position: relative;

        display: flex;

        flex-direction: column;

        gap: 40px;
    }

    .ped-right::before {
        content: "";

        position: absolute;

        left: -40px;

        top: 50%;
        bottom: 50%;

        width: 2px;

        height: calc(100% - 110px);

        background: #d9dee3;

        transform: translateY(-50%);
    }

    .branch {
        display: flex;

        align-items: center;

        gap: 60px;
    }

    .parent {
        position: relative;

        display: flex;

        align-items: center;

        justify-content: center;
    }

    .parent::after {
        content: "";

        position: absolute;

        right: -60px;

        top: 50%;

        width: 60px;

        height: 2px;

        background: #d9dee3;

        transform: translateY(-50%);
    }

    .children {
        position: relative;

        display: flex;

        flex-direction: column;

        gap: 26px;

        padding-left: 60px;
    }

    .children::before {
        content: "";

        position: absolute;

        left: 0;

        top: 50%;
        bottom: 50%;

        width: 2px;

        height: calc(100% - 90px);

        background: #d9dee3;

        transform: translateY(-50%);
    }

    .child {
        position: relative;

        display: flex;

        align-items: center;

        min-height: 120px;
    }

    .child::before {
        content: "";

        position: absolute;

        left: -60px;

        top: 50%;

        width: 60px;

        height: 2px;

        background: #d9dee3;

        transform: translateY(-50%);
    }

    .child :deep(.card-node) {
        width: 560px;
        min-width: 560px;
        max-width: 560px;
    }

    :deep(.child > .pedigree-card-wrapper > .card-node) {
        width: 560px;
        min-width: 560px;
        max-width: 560px;
    }

    :deep(.wide-details) {
        white-space: nowrap;
    }

    .ped-mid,
    .branch-spine,
    .arm,
    .to-mid {
        display: none !important;
    }

    .offspring-section {
        width: 100%;

        margin-top: 20px;

        box-sizing: border-box;
    }


    /* OFFSPRING TITLE */
    .offspring-title {
        width: 100%;

        border-bottom: none;

        padding: 4px 0;

        font-weight: 600;

        font-size: 16px;

        min-height: 28px;

        box-sizing: border-box;
    }


    .offspring-title .text-muted {
        font-weight: 400;

        margin-left: 80px;
    }


    /* OFFSPRING TABLE CONTAINER */
    .offspring-section .table-responsive {
        width: 100%;

        max-width: 100%;

        overflow-x: hidden !important;

        box-sizing: border-box;
    }


    /* OFFSPRING TABLE */
    .offspring-table {
        width: 100%;

        max-width: 100%;

        table-layout: fixed;

        border-collapse: collapse;

        border: 1px solid #000 !important;

        font-size: 12px;

        margin: 0 !important;

        box-sizing: border-box;
    }


    /* OFFSPRING CELLS */
    .offspring-table th,
    .offspring-table td {

        border: 1px solid #000 !important;

        padding: 3px 5px !important;

        height: 20px;

        vertical-align: middle;

        box-sizing: border-box;

        white-space: nowrap;

        overflow: hidden;
    }

    /* OFFSPRING HEADER */
    .offspring-table th {
        background: #e2efda;
        font-weight: 500;
        text-align: left;
    }

    /* OFFSPRING COLUMN WIDTHS */
    .offspring-table th:nth-child(1),
    .offspring-table td:nth-child(1) {
        width: 22%;
    }


    .offspring-table th:nth-child(2),
    .offspring-table td:nth-child(2) {
        width: 20%;
    }


    .offspring-table th:nth-child(3),
    .offspring-table td:nth-child(3) {
        width: 7%;

        text-align: center;
    }


    .offspring-table th:nth-child(4),
    .offspring-table td:nth-child(4) {
        width: 14%;

        text-align: center;
    }


    .offspring-table th:nth-child(5),
    .offspring-table td:nth-child(5) {
        width: 9%;

        text-align: center;
    }


    .offspring-table th:nth-child(6),
    .offspring-table td:nth-child(6) {
        width: 12%;

        text-align: center;
    }


    .offspring-table th:nth-child(7),
    .offspring-table td:nth-child(7) {
        width: 16%;
    }

    .offspring-empty {
        font-size: 12px;
        color: #777;
        padding: 5px;
    }

    .offspring-studbook-link {
        color: rgb(15, 141, 9);

        text-decoration: none;
    }

    /* PDF - LOWER SELECTED ANIMAL */
    /* Logo */

    .pdf-lower-selected-animal
    .pdf-logo-section
    > .col-lg-12 {

        position: relative;

        top: 180px;
    }


    /* Selected animal */
    .pdf-lower-selected-animal
    .pdf-animal-details {

        position: relative;

        top: 180px;
    }

    /* Pedigree */
    .pdf-lower-selected-animal
    .ped-row-right {

        position: relative;

        top: -100px;
    }

    /* RESPONSIVE */
    @media (max-width: 1200px) {

        .ped-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 30px;
        }


        .ped-right {
            gap: 24px;
        }


        .branch {
            flex-direction: column;
            align-items: flex-start;
            gap: 20px;
        }

        /* Hide connectors */
        .ped-left::after,
        .ped-right::before,
        .parent::after,
        .children::before,
        .child::before {
            display: none;
        }


        .children {
            padding-left: 0;
        }


        /* Normal cards */

        :deep(.pedigree-card-wrapper > .card-node) {
            width: 100%;
            min-width: 100%;
            max-width: 100%;
        }

        /* Last generation */

        :deep(.child > .pedigree-card-wrapper > .card-node) {

            width: 100%;

            min-width: 100%;

            max-width: 100%;
        }


        /* Tables */

        :deep(.keurpunten-table) {

            width: 100%;

            table-layout: fixed;
        }


        :deep(.keurpunten-table th),
        :deep(.keurpunten-table td) {

            padding: 2px !important;

            font-size: 11px !important;
        }
    }

    /* =========================================================
        VERY SMALL SCREENS
    ========================================================= */
    @media (max-width: 600px) {

        :deep(.keurpunten-table th),
        :deep(.keurpunten-table td) {

            padding: 2px 1px !important;

            font-size: 10px !important;
        }


        .offspring-table {

            font-size: 11px;
        }


        .offspring-table th,
        .offspring-table td {

            padding: 2px 3px !important;
        }


        :deep(.pedigree-side-label) {

            width: 24px;

            min-width: 24px;

            font-size: 10px;
        }
    }

    :deep(.pedigree-identification-row) {
        display: flex;
        align-items: center;

        width: 100%;

        margin-bottom: 4px;
    }


    :deep(.pedigree-identification-text) {
        display: flex;
        align-items: center;

        white-space: nowrap;

        flex: 1;
    }


    :deep(.pedigree-preview-icon) {
        margin-left: auto;

        display: inline-flex;

        align-items: center;
        justify-content: center;

        width: 24px;
        height: 24px;

        color: #4e61d3;

        text-decoration: none;

        cursor: pointer;

        flex-shrink: 0;
    }


    :deep(.pedigree-preview-icon:hover) {
        opacity: 0.7;
    }


    :deep(.pedigree-preview-icon i) {
        font-size: 18px;

        line-height: 1;
    }

    /* =========================================================
    PDF - SIDE LABEL
    html2canvas handles the rotated span more reliably
    than writing-mode.
    ========================================================= */

    :deep(.pdf-page .pedigree-side-label) {
        position: relative;

        width: 28px;
        min-width: 28px;

        overflow: hidden;
    }


    :deep(.pdf-page .pedigree-side-label-text) {
        position: absolute;

        left: 50%;
        top: 50%;

        white-space: nowrap;

        transform: translate(-50%, -50%) rotate(-90deg);

        transform-origin: center center;

        font-size: 11px;

        line-height: 1;

        width: auto;
        height: auto;

        margin: 0;
        padding: 0;
    }
</style>